import {SyntheticEvent, useCallback, useEffect, useRef} from 'react'

// A second click this soon after the first is taken as an accidental double click and ignored
export const clickGuardDelay = 200

/**
 * Returns a function to call first in a click handler: false (and the event's default prevented, so a submit button
 * doesn't submit its form twice) when the button was clicked less than clickGuardDelay ago.
 */
export function useClickGuard() {
    const blockedRef = useRef(false)
    const timeoutRef = useRef<number>()

    useEffect(() => {
        return () => window.clearTimeout(timeoutRef.current)
    }, [])

    return useCallback((event: SyntheticEvent) => {
        if (blockedRef.current) {
            event.preventDefault()
            return false
        }

        blockedRef.current = true
        timeoutRef.current = window.setTimeout(() => {
            blockedRef.current = false
        }, clickGuardDelay)

        return true
    }, [])
}
